var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnknownError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1082_4209)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1082_4209)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1082_4209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.907 132.841H46.2946C28.1059 132.841 13.4785 118.18 13.4785 100.076C13.4785 80.8246 28.9962 65.2706 48.2026 65.2706H117.898C137.104 65.2706 152.622 80.8246 152.622 100.076V113.207C152.495 124.044 143.719 132.841 132.907 132.841Z",
    fill: "url(#paint0_linear_1082_4209)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1082_4209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 128C115.614 128 138 105.614 138 78C138 50.3858 115.614 28 88 28C60.3858 28 38 50.3858 38 78C38 105.614 60.3858 128 88 128Z",
    fill: "url(#paint1_linear_1082_4209)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.349 132.841C147.911 132.841 162.148 118.571 162.148 100.968C162.148 83.3651 147.911 69.0951 130.349 69.0951C112.787 69.0951 98.5508 83.3651 98.5508 100.968C98.5508 118.571 112.787 132.841 130.349 132.841Z",
    fill: "url(#paint2_linear_1082_4209)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1082_4209)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 78,
    r: 26,
    fill: "url(#paint3_linear_1082_4209)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1082_4209)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.3065 68.6917C96.3842 67.7694 94.8888 67.7694 93.9666 68.6917L87.9994 74.6589L82.0327 68.6922C81.1104 67.77 79.6151 67.77 78.6928 68.6922C77.7705 69.6145 77.7705 71.1099 78.6928 72.0322L84.6595 77.9988L78.6917 83.9666C77.7694 84.8888 77.7694 86.3842 78.6917 87.3065C79.614 88.2288 81.1093 88.2288 82.0316 87.3065L87.9994 81.3387L93.9677 87.307C94.89 88.2293 96.3853 88.2293 97.3076 87.307C98.2299 86.3847 98.2299 84.8894 97.3076 83.9671L91.3393 77.9988L97.3065 72.0316C98.2288 71.1093 98.2288 69.614 97.3065 68.6917Z",
    fill: "url(#paint4_linear_1082_4209)"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1082_4209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0014136 137.575C0.0014136 137.575 4.34916 127.878 17.8647 124.076C31.4116 120.167 35.9658 115.304 35.9658 115.304",
    stroke: "url(#paint5_linear_1082_4209)",
    strokeWidth: 5.79159,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7777 121.862L29.7852 110.315C28.2822 108.718 28.3331 106.17 29.9374 104.651L38.6385 96.3191L55.2341 113.67L46.5331 122.002C44.7904 123.598 42.2806 123.459 40.7777 121.862Z",
    fill: "url(#paint6_linear_1082_4209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6445 105.353L47.3802 88.4446C45.9525 86.9856 43.6564 86.9081 42.1903 88.3507L38.2971 91.9317C36.831 93.3743 36.7361 95.6771 38.1638 97.136L54.3966 114.152C55.8243 115.611 58.1205 115.688 59.5866 114.246L63.4798 110.665C64.9773 109.114 64.9653 106.781 63.6445 105.353Z",
    fill: "url(#paint7_linear_1082_4209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1466 97.8693C46.3374 98.2115 47.585 97.5251 47.9333 96.3362C48.2816 95.1472 47.5987 93.9058 46.408 93.5635C45.2172 93.2213 43.9696 93.9077 43.6213 95.0966C43.2729 96.2856 43.9559 97.527 45.1466 97.8693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3165 108.411C56.5073 108.753 57.7549 108.067 58.1033 106.878C58.4516 105.689 57.7686 104.447 56.5779 104.105C55.3872 103.763 54.1395 104.449 53.7912 105.638C53.4429 106.827 54.1258 108.068 55.3165 108.411Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1082_4209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.244 102.348L113.685 110.314C112.916 110.891 112.639 111.998 113.211 112.767C113.783 113.537 114.884 113.81 115.654 113.233L127.213 105.267C127.982 104.69 128.259 103.583 127.687 102.814C127.115 102.044 126.014 101.771 125.244 102.348Z",
    fill: "#8F9EB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.926 112.134L120.367 120.1C119.597 120.677 119.321 121.784 119.892 122.554C120.464 123.323 121.566 123.596 122.336 123.019L133.894 115.053C134.664 114.476 134.941 113.369 134.369 112.6C133.797 111.83 132.695 111.557 131.926 112.134Z",
    fill: "#8F9EB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.402 99.6786C145.402 99.6786 152.895 99.953 156.137 93.4286C159.023 87.7699 152.81 76.4495 157.455 70.4706C163.899 62.3438 179.562 72.2717 179.562 72.2717",
    stroke: "url(#paint8_linear_1082_4209)",
    strokeWidth: 5.14052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.116 90.9267L151.594 104.894C152.912 106.803 152.404 109.48 150.496 110.811L139.965 118.007L125.82 96.9513L136.352 89.7548C138.244 88.5367 140.798 89.0183 142.116 90.9267Z",
    fill: "url(#paint9_linear_1082_4209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.414 101.895L133.082 120.561C134.114 122.085 136.222 122.502 137.744 121.46L138.257 121.076C139.78 120.034 140.205 117.918 139.173 116.394L126.505 97.7283C125.473 96.2048 123.366 95.7874 121.843 96.8292L121.33 97.2139C119.695 98.2396 119.382 100.372 120.414 101.895Z",
    fill: "url(#paint10_linear_1082_4209)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1082_4209",
    x: -6.32602,
    y: 23.0489,
    width: 188.279,
    height: 144.45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.8534
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.90227
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1082_4209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1082_4209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1082_4209",
    x: 13.4785,
    y: 65.2706,
    width: 141.62,
    height: 72.5216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.47557,
    dy: 4.95113
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.4267
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_4209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1082_4209",
    x: 38,
    y: 28,
    width: 102.476,
    height: 104.951,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.47557,
    dy: 4.95113
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.4267
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.98 0 0 0 0 0.986667 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_4209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1082_4209",
    x: 52.0977,
    y: 47.0489,
    width: 71.8045,
    height: 71.8045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.95113
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.95113
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.90864 0 0 0 0 0 0 0 0 0 0.0817002 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1082_4209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1082_4209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1082_4209",
    x: 73.0489,
    y: 65.5244,
    width: 29.9023,
    height: 29.901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.47557
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.47557
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866974 0 0 0 0 0.0815368 0 0 0 0 0.152159 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1082_4209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1082_4209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1082_4209",
    x: -12.5468,
    y: 82.3575,
    width: 87.0682,
    height: 71.2583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.95113
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.95113
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1082_4209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1082_4209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1082_4209",
    x: 103.004,
    y: 59.7528,
    width: 87.8416,
    height: 78.4292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.95113
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.95113
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1082_4209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1082_4209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1082_4209",
    x1: 83.6949,
    y1: 128.566,
    x2: 27.7959,
    y2: 69.2508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805666,
    stopColor: "#E8EBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1082_4209",
    x1: 52.1308,
    y1: 43.187,
    x2: 88.0598,
    y2: 122.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2557,
    stopColor: "#EDEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDFE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1082_4209",
    x1: 116.315,
    y1: 77.7298,
    x2: 142.615,
    y2: 115.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253072,
    stopColor: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771867,
    stopColor: "#DCDFE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1082_4209",
    x1: 103.698,
    y1: 94.0752,
    x2: 73.7015,
    y2: 54.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3D4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC093"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1082_4209",
    x1: 88.0053,
    y1: 69.1593,
    x2: 88.0053,
    y2: 88.1975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0243972,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1082_4209",
    x1: 21.6859,
    y1: 122.01,
    x2: 11.1783,
    y2: 125.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1082_4209",
    x1: 38.7509,
    y1: 99.4184,
    x2: 48.4917,
    y2: 121.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1082_4209",
    x1: 61.6401,
    y1: 113.694,
    x2: 49.1333,
    y2: 86.6782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2BCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1082_4209",
    x1: 154.746,
    y1: 81.1629,
    x2: 160.873,
    y2: 68.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1082_4209",
    x1: 134.29,
    y1: 91.8787,
    x2: 149.646,
    y2: 113.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1082_4209",
    x1: 138.847,
    y1: 119.469,
    x2: 121.616,
    y2: 100.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2BCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACFD8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1082_4209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownError);
export default __webpack_public_path__ + "static/media/unknown_error.7213b05ead423bd86343205a141acdaa.svg";
export { ForwardRef as ReactComponent };